import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { getErrorMessage } from '../../utils/helper';
import { USER_BY_ROLE, BASE_URL, UPDATE_USER, CREATE_USER } from '../../utils/constants';

export const fetchUsers = createAsyncThunk(
  'users/fetchUsers',
  async ({ role, page = 1, limit = 10, email = '' }, { rejectWithValue }) => {
    try {
      const url = `${BASE_URL}${USER_BY_ROLE}?page=${page}&limit=${limit}&role=${role}&email=${encodeURIComponent(email)}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch users'));
    }
  }
);

export const toggleUserStatus = createAsyncThunk(
  'users/toggleUserStatus',
  async ({ userId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch(`${BASE_URL}${UPDATE_USER}/${userId}/status`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to toggle user status'));
    }
  }
);

export const createUser = createAsyncThunk(
  'users/create',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(`${BASE_URL}${CREATE_USER}`, userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Error while creating user'));
    }
  }
);

export const fetchUserById = createAsyncThunk(
  'users/fetchUserById',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}${UPDATE_USER}${userId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch user details'));
    }
  }
);

export const updateUser = createAsyncThunk(
  'users/update',
  async ({ userId, userData }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${BASE_URL}${UPDATE_USER}${userId}`, userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to update user'));
    }
  }
);